import React from 'react';
import { useSeoMetadata } from './hooks/useSeoMetadata';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { Hero } from './components/sections/Hero';
import { ProofStrip } from './components/sections/ProofStrip';
import { Attention } from './components/sections/Attention';
import { MeetingLoop } from './components/sections/MeetingLoop';
import { WorkbookLoop } from './components/sections/WorkbookLoop';
import { Consequences } from './components/sections/Consequences';
import { HealthEngine } from './components/sections/HealthEngine';
import { Positioning } from './components/sections/Positioning';
import { ProjectScope } from './components/sections/ProjectScope';
import { Intelligence } from './components/sections/Intelligence';
import { SupportingControl } from './components/sections/SupportingControl';
import { DemoCta } from './components/sections/DemoCta';
type HeroVariant = 'intervention' | 'automation' | 'category';
type HealthEmphasis = 'balanced' | 'featured' | 'led';
interface AppProps {
  /** Which of the three approved hero positions leads the page. */
  heroVariant?: HeroVariant;
  /**
   * How prominent KeyTurn Health is. 'featured' adds a dedicated engine section
   * straight after the hero; 'led' also puts a portfolio read into the hero.
   */
  healthEmphasis?: HealthEmphasis;
  /** The supporting-proof strip under the hero. */
  showProofStrip?: boolean;
}
export function App({
  heroVariant = 'intervention',
  healthEmphasis = 'featured',
  showProofStrip = true
}: AppProps) {
  useSeoMetadata();
  return <div className="w-full bg-cream" data-id="element-0" data-mp="38li8rhnds9on">
      <SiteHeader data-id="element-1" data-mp="38kgkgbhctqoz" />
      <main data-id="element-2" data-mp="38o4gpie6or7e">
        <Hero variant={heroVariant} healthLed={healthEmphasis === 'led'} data-id="element-3" data-mp="3dkus3sf1mymh" />
        {showProofStrip && <ProofStrip data-id="element-4" data-mp="nvj5hlha6osd" />}
        {healthEmphasis !== 'balanced' && <HealthEngine data-id="element-5" data-mp="nv0zhx4tgw79" />}
        <Positioning data-id="element-6" data-mp="nxn5hsc273nd" />
        <div id="story" data-id="element-7" data-mp="sudl6ejybx89">
          <Attention data-id="element-8" data-mp="stub1k0jmd4s" />
        </div>
        <MeetingLoop data-id="element-9" data-mp="sssrss9dikbz" />
        <WorkbookLoop data-id="element-10" data-mp="swgi7ijiuqmh" />
        <Consequences data-id="element-11" data-mp="35yomiyqxk0x" />
        <Intelligence data-id="element-12" data-mp="35ghgrajple8" />
        <ProjectScope data-id="element-13" data-mp="34nbvtnbp1xo" />
        <SupportingControl data-id="element-14" data-mp="38b2ol1dva8p" />
        <DemoCta data-id="element-15" data-mp="3udazyhcy738x" />
      </main>
      <SiteFooter data-id="element-16" data-mp="3uc9l01st9wlx" />
    </div>;
}